<template>
    <v-sheet>
        <template v-if="items.length">
            <div class="v-cards">
                <template v-for="item in items">
                    <expo-program-item :value="item" :key="item._id">
                        <template #actions>
                            <v-row class="ma-n4">
                                <v-col cols="auto" class="pa-4">
                                    <expo-employer-form
                                        v-model="item.employer"
                                        v-bind="{
                                            program: item,
                                        }"
                                        @input="updateItem_employer"
                                    >
                                        <template #activator="{ attrs, on }">
                                            <v-btn small color="primary" class="min-w-80px min-w-lg-120px" v-bind="attrs" v-on="on">
                                                <span> 지원정보 수정 </span>
                                            </v-btn>
                                        </template>
                                    </expo-employer-form>
                                </v-col>
                                <v-col cols="auto" class="pa-4">
                                    <expo-employer-remove v-bind="{ value: item }" v-on="{ search }">
                                        <template #activator="{ attrs, on }">
                                            <v-btn small outlined color="grey-d" class="min-w-80px min-w-lg-120px" v-bind="attrs" v-on="on">
                                                <span class="grey-6--text"> 신청취소 </span>
                                            </v-btn>
                                        </template>
                                    </expo-employer-remove>
                                </v-col>
                            </v-row>
                        </template>
                    </expo-program-item>
                </template>
            </div>

            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
        </template>
        <template v-else>
            <v-layout column justify-center align-center class="w-100 grey-f7 rounded-lg pa-20" :style="innerWidth < 1024 ? { height: 'calc(100vh - 367px)' } : { height: 'calc(100vh - 472px)' }">
                <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                    안녕하세요, 담당자님. <br />
                    참여중인 프로그램이 없습니다.
                </p>
                <v-btn text height="auto" color="transparent" class="v-btn--column" href="/programs">
                    <i class="icon icon-plus-lg" />
                    <span class="mt-6 mt-lg-14 grey-9--text">프로그램 참여하기</span>
                </v-btn>
            </v-layout>
        </template>
    </v-sheet>
</template>

<script>
import api from "@/api";
import { mapState } from "vuex";
import { initExpoEmployer, initExpoProgram } from "@/assets/variables";

import ExpoProgramItem from "@/components/dashboard/common/expo/program/expo-program-item.vue";
import ExpoEmployerForm from "@/components/client/expo/employer/expo-employer-form.vue";
import ExpoEmployerRemove from "@/components/client/expo/employer/expo-employer-remove.vue";

export default {
    components: {
        ExpoProgramItem,
        ExpoEmployerForm,
        ExpoEmployerRemove,
    },
    props: {
        isActive: { type: Boolean, default: false },
    },
    data: () => ({
        programs: [],
        employers: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
    }),
    computed: {
        ...mapState("ui", { innerWidth: (store) => store.window.innerWidth }),
        items() {
            return this.programs.map((item, index) =>
                initExpoProgram({
                    ...item,
                    index: this.summary.totalCount - (this.page - 1) * this.limit - index,
                    employer: this.employers.find(({ _program }) => _program == item._id),
                })
            );
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            query.mode = query.mode ?? "on-going";

            return { ...query };
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            if (!this.isActive) return;

            this.loading = true;
            try {
                let { skip, limit, params } = this;
                let { summary, programs } = await api.v1.company.expo.employer.programs.gets({
                    headers: { skip, limit },
                    params,
                });

                this.programs = programs;
                this.summary = summary;

                let { employers } = await api.v1.company.expo.employers.gets();
                this.employers = employers.map(initExpoEmployer);
            } finally {
                this.loading = false;
            }
        },
        updateItem(item) {
            const index = this.programs.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.programs.splice(index, 1, item);
            else {
                this.programs = [item, ...this.programs];
                this.summary.totalCount += 1;
            }
            this.search();
        },
        updateItem_employer(item) {
            const index = this.employers.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.employers.splice(index, 1, item);
            else {
                this.employers = [item, ...this.employers];
            }
            this.search();
        },
    },
    watch: {
        params() {
            this.search();
        },
        loading() {
            this.$emit("setLoading", this.loading);
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style>
</style>